import CoreManagerRepository from 'coreClasses/ManagerRepository';

/**
 * Represents ManagerRepository
 */
class ManagerRepository extends CoreManagerRepository {

	/**
	 * @constructor
	 * @param {Object | null} initialState - initial redux state
	 * @param {Object} apiConfig - api config
	 * @param {Object} staticCache - static cache object
	 * @param {Object} envPreferences - env preferences object
	 * @public
	 */
	public constructor(initialState: object | null, apiConfig: object, staticCache: object, envPreferences: object) {
		super(initialState, apiConfig, staticCache, envPreferences);
	}
}

export default ManagerRepository;
